import { Link, NavLink, Navigate, Outlet, useParams } from 'react-router-dom';
import { useApp } from './AppContext';
import { StoreProvider, useStore } from './StoreContext';

const SLUG_RE = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

export function AdminLayout() {
  const { slug = '' } = useParams();
  if (!SLUG_RE.test(slug)) return <Navigate to="/" replace />;
  return (
    <StoreProvider slug={slug}>
      <AdminFrame />
    </StoreProvider>
  );
}

function AdminFrame() {
  const { slug, store, loading, error } = useStore();
  const { ready, signedIn, me, isOwner, signOut } = useApp();
  const base = `/${slug}/admin`;

  if (!ready || (loading && !store)) return <div className="page center muted">Loading…</div>;
  if (error || !store) {
    return <div className="page center"><h1>Store not found</h1><Link className="btn" to="/">All stores</Link></div>;
  }
  if (!signedIn) return <Navigate to={`/${slug}/login`} replace state={{ returnTo: base }} />;
  if (!isOwner || me?.businessSlug !== slug) {
    return (
      <div className="page center">
        <h1>Owners only</h1>
        <p className="muted">This account does not manage {store.displayName}.</p>
        <div className="row" style={{ justifyContent: 'center' }}>
          <Link className="btn" to={`/${slug}`}>Back to the store</Link>
          <button className="btn btn-ghost" onClick={signOut}>Sign out</button>
        </div>
      </div>
    );
  }

  return (
    <div className="admin">
      <header className="admin-header">
        <Link to={base} className="brand">
          {store.branding.logoUrl
            ? <img className="brand-logo" src={store.branding.logoUrl} alt="" />
            : <span className="brand-mark" aria-hidden>{store.displayName.slice(0, 1)}</span>}
          <span className="brand-name">{store.displayName} <span className="muted">· Admin</span></span>
        </Link>
        <div className="row">
          <Link className="btn btn-sm btn-ghost" to={`/${slug}`}>View store</Link>
          <button className="btn btn-sm btn-ghost" onClick={signOut}>Sign out</button>
        </div>
      </header>
      <nav className="store-nav" aria-label="Admin">
        <NavLink end to={base}>Orders</NavLink>
        <NavLink to={`${base}/menu`}>Menu</NavLink>
        <NavLink to={`${base}/settings`}>Settings</NavLink>
        <NavLink to={`${base}/media`}>Media</NavLink>
      </nav>
      <main className="store-main">
        <Outlet />
      </main>
    </div>
  );
}
